module.exports = "<p>\r\n  student-info works!!!🧡❤\r\n</p>\r\n<app-counsel-detail></app-counsel-detail>"